var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrystaltracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99021 9.48173C9.99021 9.48173 10.1164 8.61662 10.0708 8.49291C10.038 8.36907 9.4194 7.16433 9.4194 7.16433L8.98717 9.48173H9.99021Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99403 0.5L3.5362 4.61885L4.47347 9.48173H5.97803L5.96606 6.96734L4.26144 5.20897L6.28364 5.9197L7.86409 3.41456L7.1387 1.70444L8.61371 3.48689L6.65523 6.9793L6.98108 9.48173H8.48565L9.71395 3.55688L6.99403 0.5Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7279 4.92211L12.4465 7.3141L11.4948 9.48173H10.4917L10.6722 8.96033L11.8088 7.61317L10.4461 8.40132C10.1411 7.55785 9.9669 7.33437 9.71118 6.61913L10.7279 4.92211Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91499 9.98325H12.1166C13.3372 10.7071 13.2555 12.4314 12.0969 12.9924H3.97194C2.72911 12.363 2.64632 10.5666 3.9082 9.98394L3.91499 9.98325Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95336 13.7478L5.47651 15.5H7.98412L8.27037 13.7523L7.47608 13.743L7.10769 15.283L6.56843 13.7536L4.95336 13.7478Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35606 14.7868L8.98717 15.5H10.4917L10.9033 13.7476L10.3096 13.7429L10.0313 14.5492L9.99707 13.7486H8.68058C8.58365 14.1174 8.40593 14.4746 8.35606 14.7868Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H3V1.125H1.125V14.875H3V15.5H0.5V0.5Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.875H14.875V1.125H13V0.5H15.5V15.5H13V14.875Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99021 9.48173C9.99021 9.48173 10.1164 8.61662 10.0708 8.49291C10.038 8.36907 9.4194 7.16433 9.4194 7.16433L8.98717 9.48173H9.99021Z",
    fill: "current"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99403 0.5L3.5362 4.61885L4.47347 9.48173H5.97803L5.96606 6.96734L4.26144 5.20897L6.28364 5.9197L7.86409 3.41456L7.1387 1.70444L8.61371 3.48689L6.65523 6.9793L6.98108 9.48173H8.48565L9.71395 3.55688L6.99403 0.5Z",
    fill: "current"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7279 4.92211L12.4465 7.3141L11.4948 9.48173H10.4917L10.6722 8.96033L11.8088 7.61317L10.4461 8.40132C10.1411 7.55785 9.9669 7.33437 9.71118 6.61913L10.7279 4.92211Z",
    fill: "current"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91499 9.98325H12.1166C13.3372 10.7071 13.2555 12.4314 12.0969 12.9924H3.97194C2.72911 12.363 2.64632 10.5666 3.9082 9.98394L3.91499 9.98325Z",
    fill: "current"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95336 13.7478L5.47651 15.5H7.98412L8.27037 13.7523L7.47608 13.743L7.10769 15.283L6.56843 13.7536L4.95336 13.7478Z",
    fill: "current"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35606 14.7868L8.98717 15.5H10.4917L10.9033 13.7476L10.3096 13.7429L10.0313 14.5492L9.99707 13.7486H8.68058C8.58365 14.1174 8.40593 14.4746 8.35606 14.7868Z",
    fill: "current"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H3V1.125H1.125V14.875H3V15.5H0.5V0.5Z",
    fill: "current"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.875H14.875V1.125H13V0.5H15.5V15.5H13V14.875Z",
    fill: "current"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99021 9.48173C9.99021 9.48173 10.1164 8.61662 10.0708 8.49291C10.038 8.36907 9.4194 7.16433 9.4194 7.16433L8.98717 9.48173H9.99021Z",
    fill: "current"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99403 0.5L3.5362 4.61885L4.47347 9.48173H5.97803L5.96606 6.96734L4.26144 5.20897L6.28364 5.9197L7.86409 3.41456L7.1387 1.70444L8.61371 3.48689L6.65523 6.9793L6.98108 9.48173H8.48565L9.71395 3.55688L6.99403 0.5Z",
    fill: "current"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7279 4.92211L12.4465 7.3141L11.4948 9.48173H10.4917L10.6722 8.96033L11.8088 7.61317L10.4461 8.40132C10.1411 7.55785 9.9669 7.33437 9.71118 6.61913L10.7279 4.92211Z",
    fill: "current"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91499 9.98325H12.1166C13.3372 10.7071 13.2555 12.4314 12.0969 12.9924H3.97194C2.72911 12.363 2.64632 10.5666 3.9082 9.98394L3.91499 9.98325Z",
    fill: "current"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95336 13.7478L5.47651 15.5H7.98412L8.27037 13.7523L7.47608 13.743L7.10769 15.283L6.56843 13.7536L4.95336 13.7478Z",
    fill: "current"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35606 14.7868L8.98717 15.5H10.4917L10.9033 13.7476L10.3096 13.7429L10.0313 14.5492L9.99707 13.7486H8.68058C8.58365 14.1174 8.40593 14.4746 8.35606 14.7868Z",
    fill: "current"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H3V1.125H1.125V14.875H3V15.5H0.5V0.5Z",
    fill: "current"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.875H14.875V1.125H13V0.5H15.5V15.5H13V14.875Z",
    fill: "current"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99021 9.48173C9.99021 9.48173 10.1164 8.61662 10.0708 8.49291C10.038 8.36907 9.4194 7.16433 9.4194 7.16433L8.98717 9.48173H9.99021Z",
    fill: "current"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99403 0.5L3.5362 4.61885L4.47347 9.48173H5.97803L5.96606 6.96734L4.26144 5.20897L6.28364 5.9197L7.86409 3.41456L7.1387 1.70444L8.61371 3.48689L6.65523 6.9793L6.98108 9.48173H8.48565L9.71395 3.55688L6.99403 0.5Z",
    fill: "current"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7279 4.92211L12.4465 7.3141L11.4948 9.48173H10.4917L10.6722 8.96033L11.8088 7.61317L10.4461 8.40132C10.1411 7.55785 9.9669 7.33437 9.71118 6.61913L10.7279 4.92211Z",
    fill: "current"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91499 9.98325H12.1166C13.3372 10.7071 13.2555 12.4314 12.0969 12.9924H3.97194C2.72911 12.363 2.64632 10.5666 3.9082 9.98394L3.91499 9.98325Z",
    fill: "current"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95336 13.7478L5.47651 15.5H7.98412L8.27037 13.7523L7.47608 13.743L7.10769 15.283L6.56843 13.7536L4.95336 13.7478Z",
    fill: "current"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35606 14.7868L8.98717 15.5H10.4917L10.9033 13.7476L10.3096 13.7429L10.0313 14.5492L9.99707 13.7486H8.68058C8.58365 14.1174 8.40593 14.4746 8.35606 14.7868Z",
    fill: "current"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H3V1.125H1.125V14.875H3V15.5H0.5V0.5Z",
    fill: "current"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.875H14.875V1.125H13V0.5H15.5V15.5H13V14.875Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystaltracking);
export default __webpack_public_path__ + "static/media/crystaltracking.6f25882040cb00f1564cf672f0c638d9.svg";
export { ForwardRef as ReactComponent };